var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es350.js.map
